import React, { useContext, VFC } from 'react';

import { get, sortBy } from 'lodash';

import ArticleBlock from '/components/ArticleBlock';
import { ContentColumn, QuoteColumn } from '/components/BlockColumns';
import { LAYOUT, useColsCollapsed } from '/components/common';
import Title from '/components/Title';
import { BlockProps, ColumnContainerJson, Present } from '/types';
import { PresentModeContext } from '/utils/contexts';

const BlockQuote: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockBackgroundType,
  blockContent,
  blockType,
  presentOption,
  ...props
}) => {
  const colsCollapsed = useColsCollapsed();
  const columnData = get(blockContent, 'columns.list', []);
  const layout = get(blockContent, 'columns.layout');
  const isContentQuote = blockType === 'block-content-quote';
  const presentMode = useContext(PresentModeContext);

  // Quote first when collapsed
  const orderedColumns =
    colsCollapsed || layout == LAYOUT.RIGHT
      ? sortBy(columnData, (column) => (column.name === 'content' ? 1 : 0))
      : columnData;

  setAnimationComplete(animationStep >= 1);

  return (
    <ArticleBlock
      {...props}
      blockBackgroundType={blockBackgroundType}
      blockContent={blockContent}
      blockType={blockType}
      hideFooter={animationEnabled && !animationStep}
      titleCentered={!isContentQuote}
      noTitle={isContentQuote}
      titleWithinColumn={presentMode === Present.Keynote}
      columns={orderedColumns.map((column: ColumnContainerJson) => (
        <>
          {!column.hidden && column.name === 'quote' && (
            <QuoteColumn
              background={isContentQuote ? blockBackgroundType : undefined}
              elements={column.elements}
              hide={animationEnabled && !animationStep}
            />
          )}
          {!column.hidden && column.name === 'content' && (
            <>
              {(isContentQuote || presentMode === Present.Keynote) && (
                <Title
                  content={blockContent?.title?.content}
                  hidden={blockContent?.title?.hidden}
                />
              )}
              <ContentColumn
                elements={column.elements}
                presentOption={presentOption}
                hide={animationEnabled && !animationStep}
              />
            </>
          )}
        </>
      ))}
    />
  );
};

BlockQuote.displayName = 'BlockQuote';
export default BlockQuote;
